export const UserTypes = Object.freeze({
  ADMIN: "admin",
  SDR: "sdr",
  AGENT: "agent",
});
